<template>
    <ion-content class="ion-padding">

        <div class="">

            <div class="only-mobile">
                <InputTags showSearchWords="1"/>
            </div>

            <ion-grid>
                <ion-row>
                    <ion-col class="tabs__col">
                        <CustomTabs desktop="default" mobile="default" :tabs="tabs" tabId="dashboardProject">
                            <CustomTabContent v-for="tab in tabs" :key="tab.id" :tab="tab"
                                              desktop="default" mobile="default">
                                <ul v-if="tab.links">
                                    <li v-for="link in tab.links" :key="link.id">
                                        <a :href="link.href" target="_blank" :class="['text--' + link.color]">
                                            {{  link.title }}
                                        </a>
                                    </li>
                                </ul>
                            </CustomTabContent>
                        </CustomTabs>
                    </ion-col>
                </ion-row>



                <ion-row class="row__boxes">


                    <ion-col size="12" :size-sm="dashboardCol.cols" v-for="dashboardCol in dashboardCols" :key="dashboardCol.id">
                        <div class="more-icon">
                            <ion-icon name="ios-more" v-popover="{ name: dashboardCol.htmlId}"/>
                        </div>

                        <Box :box="dashboardCol.object" v-if="dashboardCol.type === 'box'"/>

                        <ion-item v-if="dashboardCol.type === 'content'">

                            <ion-lab>
                                <h2>
                                    {{ dashboardCol.object.title }}
                                </h2>

                                <code v-html="dashboardCol.object.description" v-if="dashboardCol.object.type == 1" class="content"/>
                                <div v-html="dashboardCol.object.description" v-if="dashboardCol.object.type != 1" class="content"/>
                            </ion-lab>
                        </ion-item>

                    </ion-col>
                </ion-row>
            </ion-grid>

            <popover :name="dashboardCol.htmlId" event="click" v-for="dashboardCol in dashboardCols" :key="dashboardCol.id">
                <ion-list>
                    <ion-item :href="['/#/content/edit/' + dashboardCol.foreign + '/']">
                        <ion-icon name="build"/>
                        <ion-label>
                            Inhalt
                        </ion-label>
                    </ion-item>
                    <ion-item :href="['/#/config/edit/' + dashboardCol.id + '/']">
                        <ion-icon name="apps"/>
                        <ion-label>
                            Konfiguration
                        </ion-label>
                    </ion-item>
                </ion-list>
            </popover>

        </div>

    </ion-content>

</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import 'core-js/es6/array';
    import CustomTabContent from "../components/tab/CustomTabContent";
    import Box from "../components/box/Box";
    import CustomTabs from "../components/tab/CustomTabs";
    import InputTags from "../components/tag/InputTag";

    export default {
        name: 'Dashboard',

        data(){
          return {
              dashboardBoxes: []
          }
        },
        computed: {
            tabs(){
                return this.allBoxes.filter(function(box){
                    return box.parent == 2
                });
            },

            ...mapGetters(['allBoxes', 'dashboardCols']),

        },
        methods: {
            ...mapActions(["getBoxes", "getConfigs", "getDashboard"]),
        },
        components: {
            InputTags,
            CustomTabs,
            CustomTabContent,
            Box,
        },
        async created() {
            await this.getBoxes();
            await this.getDashboard();
        }
    }



</script>

<style scoped>

    ion-icon {
        font-size:19px;
   }

    @media all and (display-mode: standalone), screen and (max-width: 768px) {
        .only-mobile {
            display: none;
        }
        ion-grid, ion-col {
            padding: 0;
        }
    }

    .row__boxes {
        margin-top: 30px;

    }
    @media all and (min-width: 768px) {
        .row__boxes ion-col {
            padding: 13px;
        }

        .tabs__col {
            padding-left: 13px;
            padding-right: 13px;
        }

    }

    .tab {
        position: fixed;
        bottom: 0;
        border-top: 1px solid gray;
        left:0;
        height: 80px;
        width: 100%;
        z-index: 1000;
        background-color: white;
        display: flex;
       justify-content: center;
    }

    .tab__item {
        margin-top: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-right: 20px;
    }

    body {
        padding-top: 0;
        background-color: #2E2D2D;
    }
    li {
        list-style-type: disc;
        padding: 8px 0;
        margin-left: 20px;
    }
    a {
        color: #B6B6B6;
    }
    input {
        color: #B6B6B6 !important;
    }
    a:hover {
        color: #B6B6B6 !important;
    }
    .text__green {
        color: #96D259 !important;
    }
    .text__yellow {
        color: #CDCA5B !important;
    }
    .text__blue {
        color: #5690BD !important;
    }
    .button__line {
        margin-top: 0;
        margin-bottom: 30px;
    }
    .fa-search {
        cursor: pointer;
    }
    .collapse {
        margin-bottom: 20px;
        margin-top: 20px;
    }
    .card-heading {
        background-color: #343638 !important;
        color: #595B5E;
        border-color: #595B5E !important;
        mso-border-shadow: no !important;
        padding: 15px;
        border-bottom: 1px solid #595B5E;
    }
    .card-body {
        background-color: #3E4143 !important;
        color: #B6B6B6 !important;
        mso-border-shadow: no !important;
        padding-top: 10px !important;
    }
    .card-default {
        border-color: #595B5E !important;
        border: 0 !important;

        box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12) !important;
    }
    .dashboard_google-search {
        width: 100%;
        margin-bottom: 30px;
    }
    .dashboard__divider {
        height: 5px;
        margin: 40px 0;
        background-color: #595B5E;
    }
    .form-control {
        background-color: #3E4143 !important;
        border-color: #595B5E !important;
    }
    .btn-default {
        background-color: #343638 !important;
        border-color: #595B5E !important;
        color: #B6B6B6;
    }
    .glyphicon {
        color: #B6B6B6 !important;
    }
    .nav-tabs {
        border-bottom: 0;
    }
    .tab__tab-list li {
        list-style: none;
        padding: 0;
        margin: 0 5px 0 0;
    }
    .tab__tab-list li a {
        background-color: #343638 !important;
        padding: 15px 20px;
        border: 0 !important;
        margin: 0;
    }
    .tab__tab-list li a:hover {
        border: 0 !important;
    }
    .tab__tab-list li.active a {
        background-color: #3E4143 !important;
        border: 0 !important;
    }
    .code__block {
        margin: 20px;
        color: #B6B6B6;
    }
    .margin-top {
        margin-top: 20px;
    }
    .tab__content-container {
        display: inline-block;
        margin-bottom: 0;
        background-color: #3E4143;
        width: 100%;
        border: 0 !important;
    }
    .tab__content-container .tab__content {
        min-height: 35px;
        margin-top: 20px;
        margin-left: 12px;
    }
    .tab__content-container table {
        border-collapse: collapse;
        border: 1px solid #B6B6B6;
    }
    .tab__content-container table td {
        color: #B6B6B6;
        padding: 15px;
    }
    .tab__content-container ul {
        padding: 0 14px 10px 14px !important;
    }
    .tab__content-container li {
        list-style-type: none;
        text-align: center;
        float: left;
        border-right: 1px solid #595B5E;
        padding: 0 16px;
        margin-left: 0;
        margin-bottom: 0;
    }
    .tab__content-container li:first-child {
        padding-left: 0;
    }
    .tab__content-container li:last-child {
        border-right: none;
    }
    @media (max-width: 768px) {
        .tab__content-container li {
            padding: 0 10px;
        }
    }

</style>